import React from "react";

export default function ContactPage() {
  return (
    <div style={styles.page}>
      {/* Hero Section */}
      <div style={styles.hero}>
        <h1 style={styles.heading}>Contact PharmaHelp</h1>
        <p style={styles.heroText}>
          We're here to help with your medicines, healthcare products,
          prescriptions, orders, and support queries.
        </p>
      </div>

      {/* Contact Card */}
      <div style={styles.container}>
        <h2 style={styles.sectionTitle}>Get In Touch</h2>

        <p style={styles.description}>
          If you have any questions, need assistance with an order, want help
          uploading a prescription, or require support regarding medicines and
          healthcare products, feel free to contact us.
        </p>

        <div style={styles.contactGrid}>
          <div style={styles.contactCard}>
            <div style={styles.icon}>📧</div>
            <h3>Email Support</h3>
            <p>info@pharmahelp.co.in</p>
          </div>

          <div style={styles.contactCard}>
            <div style={styles.icon}>📞</div>
            <h3>Phone Support</h3>
            <p>6395050131</p>
          </div>

          <div style={styles.contactCard}>
            <div style={styles.icon}>🕘</div>
            <h3>Support Hours</h3>
            <p>9:00 AM – 9:00 PM</p>
            <p>All Days</p>
          </div>
        </div>

        <div style={styles.helpBox}>
          <h3>How Can We Help?</h3>

          <ul style={styles.list}>
            <li>✔ Order related assistance</li>
            <li>✔ Prescription upload support</li>
            <li>✔ Medicine availability queries</li>
            <li>✔ Payment related support</li>
            <li>✔ Delivery related assistance</li>
            <li>✔ General healthcare product inquiries</li>
          </ul>
        </div>

        <div style={styles.footerBox}>
          <strong>PharmaHelp – Your Health, Our Priority.</strong>
        </div>
      </div>
    </div>
  );
}

const styles = {
  page: {
    background: "#f4f7fb",
    minHeight: "100vh",
    paddingBottom: "40px",
  },

  hero: {
    background: "linear-gradient(135deg, #0f172a, #2563eb)",
    color: "#fff",
    textAlign: "center",
    padding: "60px 20px",
  },

  heading: {
    margin: 0,
    fontSize: "42px",
    fontWeight: "700",
  },

  heroText: {
    marginTop: "15px",
    fontSize: "18px",
    maxWidth: "700px",
    marginLeft: "auto",
    marginRight: "auto",
  },

  container: {
    maxWidth: "1000px",
    margin: "30px auto",
    padding: "35px",
    background: "#fff",
    borderRadius: "14px",
    boxShadow: "0 4px 15px rgba(0,0,0,0.08)",
  },

  sectionTitle: {
    color: "#2563eb",
    marginBottom: "15px",
  },

  description: {
    lineHeight: 1.8,
    marginBottom: "30px",
  },

  contactGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
    gap: "20px",
    marginBottom: "35px",
  },

  contactCard: {
    background: "#f8fafc",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    padding: "20px",
    textAlign: "center",
  },

  icon: {
    fontSize: "40px",
    marginBottom: "10px",
  },

  helpBox: {
    background: "#f8fafc",
    borderRadius: "12px",
    padding: "25px",
    marginTop: "20px",
  },

  list: {
    lineHeight: "2",
    paddingLeft: "20px",
  },

  footerBox: {
    marginTop: "30px",
    padding: "20px",
    textAlign: "center",
    background: "#eff6ff",
    borderRadius: "12px",
    color: "#1e40af",
    fontSize: "18px",
  },
};